import { FormControl, TextField } from '@mui/material'

export const TextInput = ({ label, value, onChange }) => {
  return (
    <FormControl fullWidth sx={{ my: '10px' }}>
      <TextField
        fullWidth
        label={label}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  )
}
